import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApeSegmentV2, apeColorAt, rankApeSegments } from '../incepted-ape-card/incepted-ape-card-v2.component';

/**
 * Full-width per-carrier breakdown drawer for the Incepted APE card.
 * Rendered by the parent (spanning the whole grid row) so it isn't
 * constrained to a single card's column width.
 */
@Component({
  selector: 'app-incepted-ape-drawer-v2',
  imports: [CommonModule],
  templateUrl: './incepted-ape-drawer-v2.component.html',
  styleUrl: './incepted-ape-drawer-v2.component.scss'
})
export class InceptedApeDrawerComponentV2 {
  @Input() period = '';
  @Input() segments: ApeSegmentV2[] = [];

  get rankedSegments(): ApeSegmentV2[] {
    return rankApeSegments(this.segments);
  }

  get count(): number {
    return this.segments.length;
  }

  colorAt(rankIndex: number): string {
    return apeColorAt(rankIndex);
  }

  pct(segment: ApeSegmentV2): number {
    return this.total > 0 ? (segment.ape / this.total) * 100 : 0;
  }

  get total(): number {
    return this.segments.reduce((sum, seg) => sum + (seg.ape || 0), 0);
  }

  /** Carriers whose logo image failed to load — fall back to the monogram. */
  private readonly failedLogos = new Set<string>();

  /** Whether to show the logo image (present and not previously errored). */
  showLogo(segment: ApeSegmentV2): boolean {
    return !!segment.logoUrl && !this.failedLogos.has(segment.name);
  }

  onLogoError(segment: ApeSegmentV2): void {
    this.failedLogos.add(segment.name);
  }
}
